<refx-app-layout refx-text-direction [@.disabled]="animationsDisabled$ | async">
  <refx-app-header-cont appHeader [blockingReasons$]="blockingReasons$">
  </refx-app-header-cont>
  <ng-container mainContent>
    @if (!firstRouteActivated && displaySkeletalLoader) {
    <refx-app-skeleton-pres></refx-app-skeleton-pres>
    }
    <router-outlet (activate)="onRouteActivated()"></router-outlet>
  </ng-container>
  @if (!(appConfigService.isAppEmbedded$ | async)) {
  <refx-app-footer appFooter></refx-app-footer>
  }
  <refx-debug-link-pres debugContent></refx-debug-link-pres>
</refx-app-layout>
<refx-gif-spinner id="spinner" [loading]="isPending$ | async" [loadingContext]="loadingContext$ | async"
  [loadingComplete$]="loadingComplete$"></refx-gif-spinner>
<refx-lazy-outlet [loadComponent]="displayDebugPanel" [isActive]="showDebugPanel" role="complementary" aria-label="Debug panel"></refx-lazy-outlet>